import React from 'react'
import * as SurveyJS from 'survey-react'

import CreatableSelectWrapper from './CreatableSelectWrapper'

const SingleSelectWidget = {
  name: 'singleselectwidget',
  title: 'singleselectwidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    const applicableQuestions = [
      'Xplor_ChildReligion',
      'Xplor_ChildPronouns',
      'Xplor_ChildGenderIdentity',
      'Xplor_PCGenderPronouns',
      'Xplor_PCGender',
      'Xplor_ACGenderPronouns',
      'Xplor_ACGender'
    ]

    return applicableQuestions.includes(question.name)
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('singleselectwidget', [], null, 'dropdown')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <CreatableSelectWrapper question={question} isMulti={false} />
  }
}

export default SingleSelectWidget
